var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 23.0002V12.1668C13.3335 10.3259 14.8259 8.8335 16.6668 8.8335H33.3335C35.1745 8.8335 36.6668 10.3259 36.6668 12.1668V22.1668C36.6668 24.0078 35.1745 25.5002 33.3335 25.5002H22.5002",
    fill: "#00A988"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16H35H18Z",
    fill: "#A6FF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16H35",
    stroke: "#A6FF00",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 18.8335L8.0112 13.5711C9.27633 12.1478 11.0897 11.3335 12.9939 11.3335H13.3335",
    stroke: "#00A988",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 33.0004L12.5002 32.9999L19.1668 28.0004C19.1668 28.0004 20.5153 27.0879 22.5002 25.5001C26.6668 22.1669 22.5002 16.8891 18.3335 19.6661C14.9403 21.9274 11.6668 23.8338 11.6668 23.8338",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 33.0004L12.5002 32.9999L19.1668 28.0004C19.1668 28.0004 20.5153 27.0879 22.5002 25.5001C26.6668 22.1669 22.5002 16.8891 18.3335 19.6661C14.9403 21.9274 11.6668 23.8338 11.6668 23.8338",
    stroke: "#00A988",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.04a78072ca15aa45a1c2ea343e25a1ea.svg";
export { ForwardRef as ReactComponent };